import { inject, isDevMode, NgModule, provideAppInitializer } from '@angular/core';
import { provideTransloco, TranslocoModule } from '@jsverse/transloco';

import { defaultUiLanguageCode, uiLanguageCodes } from '../models/language.model';
import { UiLanguageService } from '../services/ui-language.service';
import { TranslocoHttpLoader } from './transloco-http.loader';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslocoPaginatorIntl } from './transloco-paginator-intl';

/**
 * Root i18n configuration. Imported once by the AppModule.
 *
 * Translations are organised per feature: every lazy feature module registers
 * its own scope (see `provideTranslocoScope` in the feature modules) and owns
 * the files under `assets/i18n/<feature>/`. The root files
 * (`assets/i18n/<lang>.json`) hold only the app shell and shared component
 * texts. Features never read each other's keys.
 */
@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: [...uiLanguageCodes],
        defaultLang: defaultUiLanguageCode,
        fallbackLang: defaultUiLanguageCode,
        // Missing keys fall back to the default language instead of rendering the key.
        missingHandler: {
          useFallbackTranslation: true,
          logMissingKey: isDevMode(),
        },
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader,
    }),
    // Applies the language stored in the user preferences before the app renders.
    provideAppInitializer(() => inject(UiLanguageService).initialize()),
    // Material's paginator labels, from the root translation file.
    { provide: MatPaginatorIntl, useClass: TranslocoPaginatorIntl },
  ],
})
export class TranslocoRootModule { }
